export const embedded = window.parent !== window;
